/* Sticky Add to Cart — Shana Gulati Jewelry (Madrid theme) */
document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('sticky-atc');
  if (!bar) return;

  var qtyInput     = bar.querySelector('.js-sticky-qty');
  var minusBtn     = bar.querySelector('.js-sticky-minus');
  var plusBtn      = bar.querySelector('.js-sticky-plus');
  var atcBtn       = bar.querySelector('.js-sticky-atc-btn');
  var btnText      = atcBtn.querySelector('.btn-text');
  var stickySelect = bar.querySelector('.js-sticky-variant');

  // --- Visibility: show bar once the main ATC scrolls out of view ---
  var pageBtn = document.querySelector('.product-form__cart-submit, [data-product-form] [name="add"], form[action*="/cart/add"] [type="submit"], .product-form__submit, button[name="add"]');

  if (pageBtn && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
    }, { threshold: 0 });
    obs.observe(pageBtn);
  } else {
    window.addEventListener('scroll', function () {
      var show = window.scrollY > 400;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
    }, { passive: true });
  }

  // --- Quantity controls ---
  if (minusBtn) minusBtn.addEventListener('click', function () {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
  });
  if (plusBtn) plusBtn.addEventListener('click', function () {
    qtyInput.value = Math.min(99, parseInt(qtyInput.value, 10) + 1);
  });
  qtyInput.addEventListener('change', function () {
    var v = parseInt(qtyInput.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (v > 99) v = 99;
    qtyInput.value = v;
  });

  // --- Keep sticky variant in sync with main form ---
  var mainVariantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (stickySelect && mainVariantInput) {
    stickySelect.addEventListener('change', function () {
      mainVariantInput.value = stickySelect.value;
      mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var syncFromMain = function () {
      if (mainVariantInput.value) stickySelect.value = mainVariantInput.value;
    };
    mainVariantInput.addEventListener('change', syncFromMain);
    new MutationObserver(syncFromMain).observe(mainVariantInput, { attributes: true, attributeFilter: ['value'] });
  }

  // --- Update Madrid's cart count badge ---
  function updateCartCount(cart) {
    if (!cart) return;
    var count = cart.item_count;
    // Common cart count selectors across Madrid and other Sandbox themes
    var selectors = [
      '.cart-count',
      '.cart-link__bubble',
      '.cart-link__bubble-num',
      '[data-cart-count]',
      '.site-header__cart-count',
      '.header__cart-count',
      '.cart-count-bubble',
      '.cart-icon-bubble',
      '#CartCount',
      '#cart-count',
      '.cart_count',
      '[data-header-cart-count]',
      '.js-cart-count'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = count;
        el.classList.remove('hidden-count', 'hide', 'is-empty');
        if (count > 0) el.classList.add('has-items');
      });
    });
  }

  // --- Try to open Madrid's cart drawer ---
  function openCartDrawer() {
    // 1) Madrid / Sandbox themes often expose theme.CartDrawer or CartDrawer global
    if (window.theme && window.theme.CartDrawer && typeof window.theme.CartDrawer.open === 'function') {
      try { window.theme.CartDrawer.open(); return true; } catch (e) {}
    }
    if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
      try { window.CartDrawer.open(); return true; } catch (e) {}
    }

    // 2) Try clicking a cart drawer trigger if present
    var triggers = [
      '[data-cart-drawer-trigger]',
      '[data-action="open-drawer"][data-drawer="cart"]',
      '.js-drawer-open-cart',
      '.cart-link[data-drawer]',
      'a.site-header__cart',
      '.header__icon--cart'
    ];
    for (var i = 0; i < triggers.length; i++) {
      var el = document.querySelector(triggers[i]);
      if (el) {
        el.click();
        return true;
      }
    }

    // 3) Fire common cart open events that Madrid/Sandbox themes listen for
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('drawerOpen'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    return false;
  }

  // --- AJAX Add to Cart ---
  atcBtn.addEventListener('click', function () {
    var variantId = (stickySelect && stickySelect.value) || (mainVariantInput && mainVariantInput.value);
    if (!variantId) {
      alert('Please select a variant first.');
      return;
    }

    atcBtn.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: parseInt(qtyInput.value, 10) })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function (addedItem) {
      // Now fetch the full cart to get updated count
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart);

          // Fire all the common events Madrid / Sandbox themes might listen for
          document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: addedItem } }));
          document.dispatchEvent(new CustomEvent('product:added', { detail: { product: addedItem } }));
          // Shopify's own published event (some themes listen)
          if (window.PubSub && typeof window.PubSub.publish === 'function') {
            try { window.PubSub.publish('cart-update', { cart: cart }); } catch (e) {}
          }

          // Success state
          atcBtn.classList.remove('loading');
          atcBtn.classList.add('success');
          btnText.textContent = 'Added \u2713';

          // Open cart drawer after a short delay so the badge animation is visible
          setTimeout(function () { openCartDrawer(); }, 300);

          setTimeout(function () {
            atcBtn.classList.remove('success');
            btnText.textContent = 'Add to Cart';
          }, 2000);
        });
    })
    .catch(function (err) {
      atcBtn.classList.remove('loading');
      alert((err && err.description) || 'Something went wrong. Please try again.');
    });
  });
});